import { render, staticRenderFns } from "./tumorTestList.vue?vue&type=template&id=53e94618&scoped=true"
import script from "./tumorTestList.vue?vue&type=script&lang=js"
export * from "./tumorTestList.vue?vue&type=script&lang=js"
import style0 from "./tumorTestList.vue?vue&type=style&index=0&id=53e94618&prod&scoped=true&lang=css"
import style1 from "./tumorTestList.vue?vue&type=style&index=1&id=53e94618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e94618",
  null
  
)

export default component.exports